import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@onsolve/onsolve-ui-components';
import { RedirectForm } from 'components/Base';
import { locationService } from 'services';
import './SignInExternalProvider.scss';
import { useIntl } from 'react-intl';
import { signInTranslations } from 'translations';

import { useHistory } from 'react-router';
import { providers } from './Constants';
import { isCRC168Enabled } from 'featureFlags';

const SignInExternalProvider = ({ externalProvidersEnabled, guestEnrollmentEnabled }) => {
    const intl = useIntl();
    const history = useHistory();

    return (
        <div className="onsolve-custom-sign-in-external__content-wrapper">
            <legend className="onsolve-divider text text-secondary mb-3 onsolve-divider--text">
                {intl.formatMessage(signInTranslations.ng_signIn_externalSsoSignIn)}
            </legend>
            {externalProvidersEnabled &&
                providers.map((provider) => (
                    <RedirectForm
                        key={provider.name}
                        to={provider.url}
                        params={{ returnUrl: locationService.queryStringParams.ReturnUrl, externalIdp: provider.name }}
                        className="onsolve-custom-sign-in-external__form-container"
                        ariaLabel={
                            isCRC168Enabled()
                                ? `${intl.formatMessage(signInTranslations.ng_signIn_externalSsoSignInButton)} ${
                                      provider.title
                                  }`
                                : undefined
                        }
                    >
                        <Button
                            role="button"
                            size="lg"
                            color="secondary"
                            className="onsolve-custom-sign-in-external__btn"
                            type="submit"
                        >
                            <span className="onsolve-custom-sign-in__external-btn-icon">{provider.icon}</span>
                            <span className="onsolve-custom-sign-in__external-btn-text">
                                {intl.formatMessage(signInTranslations.ng_signIn_externalSsoSignInButton)}{' '}
                                {provider.title}
                            </span>
                        </Button>
                    </RedirectForm>
                ))}
            {guestEnrollmentEnabled && (
                <Button
                    role="button"
                    size="lg"
                    color="secondary"
                    className="onsolve-custom-sign-in-external__btn onsolve-custom-sign-in-external__btn--guest-enrollment"
                    type="submit"
                    onClick={() =>
                        history.push({
                            pathname: '/ContactMethod',
                            search: locationService.queryStringParams.ReturnUrl
                                ? `?ReturnUrl=${encodeURIComponent(locationService.queryStringParams.ReturnUrl)}`
                                : undefined,
                            state: { guestEnrollmentEnabled },
                        })
                    }
                >
                    <span className="onsolve-custom-sign-in__external-btn-text">
                        {intl.formatMessage(signInTranslations.ng_signIn_guestEnrollmentButton)}
                    </span>
                </Button>
            )}
        </div>
    );
};

SignInExternalProvider.propTypes = {
    externalProvidersEnabled: PropTypes.bool,
    guestEnrollmentEnabled: PropTypes.bool,
};

export default SignInExternalProvider;
